/**
 * Page Loader Component
 * Loading fallback for lazy-loaded routes
 */

import { Box, CircularProgress, Typography } from '@mui/material';

interface PageLoaderProps {
  message?: string;
}

/**
 * Page Loader
 * Displays a centered loading indicator with optional message
 * Used as Suspense fallback for lazy-loaded routes
 */
export const PageLoader: React.FC<PageLoaderProps> = ({ message = 'Loading...' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2,
      }}
    >
      <CircularProgress size={48} />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
    </Box>
  );
};
